
@if (availablePaymentMethods.length == 1) {

    @if (availablePaymentMethods[0] == 'hold') {
        <h2 class="mt-5">{{"pr.paymentHeaderSingleHold"|translate}}</h2>
    }
    @else {
        <h2 class="mt-5">{{"pr.paymentHeaderSingleCc"|translate}}</h2>
    }
}

@if (availablePaymentMethods.length > 1) {

    <h2 class="mt-5">{{"pr.paymentHeader"|translate}}</h2>

    <div class="payment-buttons">
        @if (availablePaymentMethods.includes('cc')) {
            <div class="payment-selection" (click)="selectPaymentMethod('cc')" [class.active]="selectedPaymentMethod == 'cc'">
                <span class="payment-selection-icon material-symbols-outlined">
                    credit_card
                </span>
                <span class="payment-selection-text">{{"pr.buttonCC"|translate}}</span>
            </div>
        }
        @if (availablePaymentMethods.includes('hold')) {
            <div class="payment-selection"  [class.disabled]="forcePrepaid" (click)="selectPaymentMethod('hold')" [class.active]="selectedPaymentMethod == 'hold'">
                <span class="payment-selection-icon material-symbols-outlined">
                    concierge
                </span>
                <span class="payment-selection-text">{{"pr.buttonHold"|translate}}</span>
            </div>
        }
    </div>

    @if (forcePrepaid) {
        <p-message severity="secondary" class="mt-3 d-block payment-validation-message">
            {{'pr.BookingIsPrepaidBecauseOneOrMoreRoomsIsPrepaid'|translate}}
        </p-message>
    }
}

@if (!availablePaymentMethods.includes('cc') && shopCartHasExternalExtras && forcePrepaid) {
    <p-message severity="secondary" class="mt-3 d-block payment-validation-message">
        {{'pr.BookingIsPrepaidHasExternalExtras'|translate}}
    </p-message>
}

@if (selectedPaymentMethod == 'hold') {
    <div class="payment-method-container">
        @if (availablePaymentMethods.length > 1) {
            <h4>{{"pr.paymentHeaderHold"|translate}}</h4>
        }
        <p>{{"pr.paymentTextHold"|translate}}</p>

        <!-- @if (cancellationPolicies.length) {
            <div class="cancellationPolicies">
                <h4>{{"pr.CancellationPolicies"|translate}}</h4>
                @for (cp of cancellationPolicies; track $index) {
                    <div class="cp">@if (cp.roomNumber.length > 1){ {{"pr.Rooms" | translate}} }@else{ {{"pr.Room" | translate}} } @for (roomNumber of cp.roomNumber; track $index; let idx = $index) { {{roomNumber}}@if(!$last){@if(idx == $count -2 ){ &}@else{,} } }: {{cp.policy}}</div>
                }
            </div>
        } -->


        @for (vs of validationData; track $index) {
            @if (!vs?.isValid) {
                <p-message severity="error" class="mt-3 d-block payment-validation-message" [attr.data-testid]="'booking-validation-error'">
                    <div class="payment-validation-error-texts">

                        <b>@if (roomCount > 1) { {{"pr.Room"|translate}} {{$index+1}}:  } {{'pr.fillFollowingInfoToContinue'|translate}}:</b>
                        @for (item of vs?.invalidControls; track $index) {
                            {{'pr.'+item|translate}}@if (!$last) {, }
                        }
                    </div>
                    <p-button icon="pi pi-home" [rounded]="true" class="ms-auto" (click)="scrollToBookerDetails($index);" [attr.data-testid]="'booking-scroll-to-details'">
                        <span class="material-symbols-outlined">
                            keyboard_arrow_up
                        </span>
                    </p-button>
                </p-message>
            }
        }

        @if (reservationErrorMessage) {
            <p-message severity="error" class="mt-3 d-block" [attr.data-testid]="'booking-reservation-error'">
                <span class="material-symbols-outlined">
                    error
                </span> {{reservationErrorMessage}}
            </p-message>
        }


        <div class="book-button-container row">
            <div class="col-12 col-md-7 mb-3 termsAndConditionsWrapper">
                <p-checkbox [formControl]="acceptTerms"  binary="true" value="acceptTerms" inputId="termsAndConditions" [attr.data-testid]="'booking-accept-terms'"/>&nbsp;
                <label for="termsAndConditions">{{'pr.IHaveReadAndAccept'|translate}}</label>&nbsp;
                <a class="tc-link" (click)="openTermsAndConditions()" [attr.data-testid]="'booking-terms-drawer-open'">
                    {{'pr.TermsAndConditions'|translate}}
                    @if (!settings.get('profile.termsAndConditionsAsModal')) {
                        <span class="material-symbols-outlined" [pTooltip]="'pr.OpensInNewTab'|translate" tooltipPosition="bottom">
                            open_in_new
                        </span>
                    }
                </a>
            </div>

            @if (allRoomsValidated && !acceptTerms.valid) {
                <p-message severity="error" class="d-inline-block payment-validation-message payment-terms-message mb-3" [attr.data-testid]="'booking-validation-error-terms'">
                    <span class="material-symbols-outlined">
                        info
                    </span>
                    {{"pr.AcceptTermsInfo"|translate}}
                </p-message>
            }

            <div>
                <p-button (click)="makeReservation()" styleClass="book-cta-button" [disabled]="!allRoomsValidated || !acceptTerms.valid " [attr.data-testid]="'booking-make-reservation'">{{"pr.bookButtonHold"|translate}}</p-button>
            </div>



        </div>
    </div>
}

@if (selectedPaymentMethod == 'cc') {

    <div class="payment-method-container">

    @if (paymentServiceUnavailable) {
        <p-message severity="error" class="mt-3 d-block" [attr.data-testid]="'booking-payment-service-unavailable'">
            <span class="material-symbols-outlined">
                error
            </span> {{'pr.PaymentServiceUnavailable'|translate}}
        </p-message>
    }

    @if (paymentServiceProvider == 'viva') {
        
            @if (availablePaymentMethods.length > 1) {
                <h4>{{"pr.paymentHeaderCC"|translate}}</h4>
            }
            <div class="row mb-4">
                <div class="col-12 col-md-6">
                    <div>{{"pr.paymentTextViva"|translate}}</div>
                </div>
                <div class="col-12 col-md-6 d-flex align-items-end gap-3 selected-payment-method-wrap">
                    <img src="/viva/Finland429x51.svg" class="viva-banner w-100">
                </div>

            </div>


            @for (vs of validationData; track $index) {
                @if (!vs?.isValid) {
                    <p-message severity="error" class="mt-3 d-block payment-validation-message" [attr.data-testid]="'booking-validation-error'">
                        <div class="payment-validation-error-texts">

                            <b>@if (roomCount > 1) { {{"pr.Room"|translate}} {{$index+1}}:  } {{'pr.fillFollowingInfoToContinue'|translate}}:</b>
                            @for (item of vs?.invalidControls; track $index) {
                                {{'pr.'+item|translate}}@if (!$last) {, }
                            }
                        </div>
                        <p-button icon="pi pi-home" [rounded]="true" class="ms-auto" (click)="scrollToBookerDetails($index);">
                            <span class="material-symbols-outlined">
                                keyboard_arrow_up
                            </span>
                        </p-button>
                    </p-message>
                }
            }

            @if (reservationErrorMessage) {
                <p-message severity="error" class="mt-3 d-block" [attr.data-testid]="'booking-reservation-error'">
                    <span class="material-symbols-outlined">
                        error
                    </span> {{reservationErrorMessage}}
                </p-message>
            }

            
    
    }

    @if (paymentServiceProvider == 'paytrail') {
            @if (availablePaymentMethods.length > 1) {
                <h4>{{"pr.paymentHeaderCC"|translate}}</h4>
            }
            <div class="row mb-4">
                <div class="col-12 col-md-6">
                    <h4>{{"pr.choosePaymentMethod"|translate}}</h4>
                    <div>{{"pr.paymentTextPaytrail"|translate}}</div>
                </div>
                <div class="col-12 col-md-6 d-flex align-items-end gap-3 selected-payment-method-wrap">
                    <img src="https://www.paytrail.com/hubfs/paytrail-logo-250px.png" class="paytrail-banner">
                    @if (selectedPaymentOption) {
                        <div class="">
                            <label>{{"pr.selectedPaymentOption"|translate}}</label>

                            <div class="paytrail-payment-button isSelectedOption">
                                <div class="payment-option-logo-wrap">
                                    <img class="payment-option-logo" [src]="selectedPaymentButton?.logo">
                                </div>
                                <div class="payment-option-name">
                                    {{selectedPaymentButton?.text}}
                                </div>
                            </div>

                        </div>
                        <p-button [outlined]="true" (click)="clearPaymentOption()">{{"pr.changePaymentOption"|translate}}</p-button>
                    }
                </div>

                @if (paymentOptions) {
                    <app-paytrail-payment-form [paymentFormData]="paymentOptions" [class.hidden]="selectedPaymentOption" (onPaymentSelected)="setSelectedPaymentOption($event)"></app-paytrail-payment-form>
                }

            </div>

            <!-- <div class="row">
                <div class="col-12">
                    @if (cancellationPolicies.length) {
                        <div class="cancellationPolicies">
                            <h4>{{"pr.CancellationPolicies"|translate}}</h4>
                            @for (cp of cancellationPolicies; track $index) {
                                <div class="cp">@if (cp.roomNumber.length > 1){ {{"pr.Rooms" | translate}} }@else{ {{"pr.Room" | translate}} } @for (roomNumber of cp.roomNumber; track $index; let idx = $index) { {{roomNumber}}@if(!$last){@if(idx == $count -2 ){ &}@else{,} } }: {{cp.policy}}</div>
                            }
                        </div>
                    }
                </div>
            </div> -->

            @for (vs of validationData; track $index) {
                @if (!vs?.isValid) {
                    <p-message severity="error" class="mt-3 d-block payment-validation-message" [attr.data-testid]="'booking-validation-error'">
                        <div class="payment-validation-error-texts">

                            <b>@if (roomCount > 1) { {{"pr.Room"|translate}} {{$index+1}}:  } {{'pr.fillFollowingInfoToContinue'|translate}}:</b>
                            @for (item of vs?.invalidControls; track $index) {
                                {{'pr.'+item|translate}}@if (!$last) {, }
                            }
                        </div>
                        <p-button icon="pi pi-home" [rounded]="true" class="ms-auto" (click)="scrollToBookerDetails($index);">
                            <span class="material-symbols-outlined">
                                keyboard_arrow_up
                            </span>
                        </p-button>
                    </p-message>
                }
            }

            @if (reservationErrorMessage) {
                <p-message severity="error" class="mt-3 d-block" [attr.data-testid]="'booking-reservation-error'">
                    <span class="material-symbols-outlined">
                        error
                    </span> {{reservationErrorMessage}}
                </p-message>
            }

            
        
    }
        <div class="book-button-container">
            <div class="col-12 col-md-6 mb-3 termsAndConditionsWrapper">
                <p-checkbox [formControl]="acceptTerms"  binary="true" inputId="termsAndConditions" [attr.data-testid]="'booking-accept-terms'" />&nbsp;
                <label for="termsAndConditions">{{'pr.IHaveReadAndAccept'|translate}}</label>&nbsp;
                <a class="tc-link" (click)="openTermsAndConditions()" [attr.data-testid]="'booking-terms-drawer-open'">
                    {{'pr.TermsAndConditions'|translate}}
                    @if (!settings.get('profile.termsAndConditionsAsModal')) {
                        <span class="material-symbols-outlined" [pTooltip]="'pr.OpensInNewTab'|translate" tooltipPosition="bottom">
                            open_in_new
                        </span>
                    }
                </a>
            </div>

            @if (allRoomsValidated && !acceptTerms.valid) {
                <p-message severity="error" class="d-inline-block payment-validation-message payment-terms-message" [attr.data-testid]="'booking-validation-error-terms'">
                    <span class="material-symbols-outlined">
                        info
                    </span>
                    {{"pr.AcceptTermsInfo"|translate}}
                </p-message>
            }

            <p-button (click)="makePayment()" styleClass="book-cta-button" [disabled]="!allRoomsValidated || !acceptTerms.valid" [attr.data-testid]="'booking-make-reservation'">{{"pr.bookButtonCC"|translate}}</p-button>



        </div>
    
    </div>
}

<p-drawer [(visible)]="termsAndConditionsOpened" header="&nbsp;" styleClass="termsAndConditionsModal" [attr.data-testid]="'booking-terms-drawer'">
    <div [innerHTML]="termsAndConditionsModalContent"></div>
    <div class="tc-bottom"><p-button (click)="acceptTermsInModal()" [attr.data-testid]="'booking-terms-drawer-accept'">{{'pr.IHaveReadAndAccept'|translate}} {{'pr.TermsAndConditions'|translate}}</p-button></div>
</p-drawer>
